import { LOGIN, LOGOUT, CLEAR_LOGIN_ERROR } from '../type';

export function userReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN: {
      return payload;
    }
    case LOGOUT: {
      return payload;
    }
    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}
